import React from "react";
import { Box, Typography } from "@mui/material";
const Count = ({ days = 0, hours = 0, minutes = 0, seconds = 0 }) => {
  const items = [
    { value: days, label: "DAYS" },
    { value: hours, label: "HOURS" },
    { value: minutes, label: "MINUTES" },
    { value: seconds, label: "SECONDS" },
  ];

  const format2 = (n) => String(Math.max(0, n)).padStart(2, "0");

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, 1fr)", sm: "repeat(4, 1fr)" },
        gap: { xs: "12px", sm: "14px", md: "18px" },
        padding: { xs: "12px", sm: "14px", md: "18px" },
        borderRadius: "24px",
        backgroundColor: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.18)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        boxShadow: "0 18px 60px rgba(0,0,0,0.35)",
      }}
    >
      {items.map((it) => (
        <Box
          key={it.label}
          sx={{
            position: "relative",
            borderRadius: "18px",
            padding: { xs: "14px 12px", sm: "16px 12px", md: "18px 12px" },
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.14), rgba(255,255,255,0.06))",
            border: "1px solid rgba(255,255,255,0.16)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(260px 160px at 20% 20%, rgba(35, 174, 244, 0.20), transparent 55%), radial-gradient(240px 160px at 80% 80%, rgba(255, 0, 128, 0.14), transparent 55%)",
              pointerEvents: "none",
            }}
          />
          <Typography
            sx={{
              position: "relative",
              color: "#fff",
              fontWeight: 900,
              fontSize: { xs: "34px", sm: "40px", md: "48px" },
              lineHeight: 1,
              letterSpacing: "-0.02em",
            }}
          >
            {format2(it.value)}
          </Typography>
          <Typography
            sx={{
              position: "relative",
              mt: 0.75,
              color: "rgba(255,255,255,0.8)",
              fontWeight: 700,
              letterSpacing: "0.12em",
              fontSize: { xs: "11px", sm: "12px", md: "13px" },
            }}
          >
            {it.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Count;
